import { observer } from 'mobx-react';
import useAsyncEffect from 'use-async-effect';
import { SpcSteps } from './SpcModels';
import { useParams } from 'react-router-dom';
import SpcViewModel from './SpcViewModel';
import { Appl } from '../../../../core/Appl';
import MedicalLeaveForm from './3_1_MedicalLeaveForm';
import { SpcStepStatus } from './SpcSidebarFormNavigation';
import TempEmploymentForm from './3_2_TempEmploymentForm';
import RedepositForm from './3_3_RedepositForm';
import PublicServiceForm from './3_4_PublicServiceForm';

const EnterDetails = observer(() => {
  const vm = Appl.Services.get<SpcViewModel>('SpcViewModel');
  let { memberId } = useParams();

  useAsyncEffect(async () => {
    if (vm.model.estimateDetails && vm.model.estimateDetails.length > 0) {
      if (vm.isAddingEstimate || vm.isEditingEstimate) {
        await vm.loadStepAsync(SpcSteps.EnterDetails, memberId!, vm.model?.spcTypeId, vm.model?.submissionId);
      }
      else {
        await vm.setStepStatus(SpcSteps.EnterDetails, SpcStepStatus.Completed);
        await vm.navigateToStepAsync(SpcSteps.Summary);
      }
    }
    else {
      await vm.loadStepAsync(SpcSteps.EnterDetails, memberId!);
    }

  }, []);


  return (
      <div className="w-full max-w-[870px] mx-auto">
          {vm.model?.spcTypeId===1 && <MedicalLeaveForm />}
          {vm.model?.spcTypeId===2 && <TempEmploymentForm/>}
          {vm.model?.spcTypeId===3 && <RedepositForm />}
          {vm.model?.spcTypeId===4 && <PublicServiceForm/>}
      </div>
  );
});

export default EnterDetails;
